import React from 'react';
import { injectGlobal } from '@emotion/css';

injectGlobal`
  body.dont-scroll-me {
    overflow-x: hidden;
    overflow-y: hidden;
  }
`;

const defaultGetElement = () => {
  const list = document.getElementsByTagName('body');
  if (list.length > 0) return list[0];
  return null;
};

const withBodyNoScroll =
  (getElement = defaultGetElement) =>
  Component => {
    class WithBodyNoScroll extends React.Component {
      componentDidMount() {
        const body = getElement();
        if (body) body.classList.add('dont-scroll-me');
      }

      componentWillUnmount() {
        const body = getElement();
        if (body) body.classList.remove('dont-scroll-me');
      }

      render() {
        return <Component {...this.props} />;
      }
    }

    WithBodyNoScroll.displayName = `withBodyNoScroll(${
      Component.displayName || Component.name || 'Component'
    })`;

    return WithBodyNoScroll;
  };

export default withBodyNoScroll;
